module.exports = require("lodash/set");


//////////////////
// WEBPACK FOOTER
// external "lodash/set"
// module id = 65
// module chunks = 0 1 2 3 4 5 6 7 10 11